import React, { Component } from 'react';
import _ from 'lodash';
import draftToHtml from 'draftjs-to-html';
import { Image, BackgroundImage, Search, MainSlider } from '../components';
import { withRedux } from '../hoc';
import { getServiceUrl } from '../utils';
import { getPageaboutAction } from '../actions/page/about';

const mapStateToProps = state => {
  return {
    t: _.get(state, 't'),
    languages: _.get(state, 'languages'),
    page: _.get(state, 'page')
  };
};

const actions = {
  getPageaboutAction
};

@withRedux(mapStateToProps, actions)
export default class About extends Component {
  componentDidMount() {
    this.props.actions.getPageaboutAction();
  }
  render() {
    const { t } = this.props;
    const data = _.get(this.props, 'page.about.data');
    const media_our_history_image_full_file_path = `${getServiceUrl()}/${_.get(
      data,
      'media_our_history_image_data.path'
    )}`;
    const media_our_history_banner_full_file_path = `${getServiceUrl()}/${_.get(
      data,
      'media_our_history_banner_data.path'
    )}`;
    const media_our_missions_image_full_file_path = `${getServiceUrl()}/${_.get(
      data,
      'media_our_missions_image_data.path'
    )}`;
    const media_our_values_background_full_file_path = `${getServiceUrl()}/${_.get(
      data,
      'media_our_values_background_data.path'
    )}`;
    const media_our_goals_image_full_file_path = `${getServiceUrl()}/${_.get(data, 'media_our_goals_image_data.path')}`;

    return (
      <div className="about-page container-wrapper">
        <div className="search-block">
          <Search.Main />
        </div>
        <div className="banner-block">
          <div
            className="topic"
            dangerouslySetInnerHTML={{
              __html: t({
                en: '- <span className="text-red">About</span> KKC -',
                th: '- เกี่ยวกับเรา -'
              })
            }}
          />
          <div className="media-slide">
            <MainSlider data={_.get(this.props, 'page.about.data.image_slide')} />
          </div>
        </div>
        <div className="section-1">
          <div className="top-panel">
            <div className="container">
              <div className="title">{t('Our History')}:</div>
            </div>
          </div>
          <div className="content-panel">
            <div className="container">
              <div className="row">
                <div className="col-md-6">
                  <div className="company-text">
                    <div
                      className="descriptions wysiwyg"
                      dangerouslySetInnerHTML={{
                        __html: draftToHtml(t(_.get(data, 'our_history_text')))
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="image">
                    <Image src={media_our_history_image_full_file_path} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section-2">
          <BackgroundImage image={media_our_history_banner_full_file_path}>
            <div className="text">{t(_.get(data, 'our_history_banner_text'))}</div>
          </BackgroundImage>
        </div>
        <div className="section-3">
          <div className="top-panel">
            <div className="container">
              <div className="title">{t('Our Missions')}:</div>
            </div>
          </div>
          <div className="content-panel">
            <div className="container">
              <div className="row">
                <div className="col-md-5">
                  <div className="missions">
                    <div className="block">
                      <div className="title">{t('Vision')}</div>
                      <div
                        className="detail wysiwyg"
                        dangerouslySetInnerHTML={{
                          __html: draftToHtml(t(_.get(data, 'our_missions_text_vision')))
                        }}
                      />
                    </div>
                    <div className="block">
                      <div className="title">{t('Missions')}</div>
                      <div
                        className="detail wysiwyg"
                        dangerouslySetInnerHTML={{
                          __html: draftToHtml(t(_.get(data, 'our_missions_text_missions')))
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-7">
                  <div className="image">
                    <Image src={media_our_missions_image_full_file_path} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section-4">
          <BackgroundImage image={media_our_values_background_full_file_path} />
          <div className="top-panel">
            <div className="container">
              <div className="title">{t('Our Values')}:</div>
            </div>
          </div>
          <div className="content-panel">
            <div className="container">
              <div className="row row-1">
                {_.map(_.get(data, 'our_values_blocks'), (value, key) => {
                  const size = 12 / _.size(_.get(data, 'our_values_blocks'));
                  const media_image_full_file_path = `${getServiceUrl()}/${_.get(value, 'media_image_data.path')}`;
                  return (
                    <div key={key} className={`col-md-${size}`}>
                      <div className="item-block">
                        <div className="image">
                          <BackgroundImage image={media_image_full_file_path} />
                        </div>
                        <div className="name">{t(_.get(value, 'text'))}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="row row-2">
                <div className="col-md-12">
                  <div className="detail-block">
                    <div className="title">- {t('Brand Philosophy')} -</div>
                    <div
                      className="description"
                      dangerouslySetInnerHTML={{
                        __html: t(_.get(data, 'our_values_philosophy'))
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section-5">
          <div className="top-panel">
            <div className="container">
              <div className="title">{t('Our Goals')}:</div>
            </div>
          </div>
          <div className="content-panel">
            <div className="container">
              <div className="row">
                <div className="col-md-5">
                  <div
                    className="detail wysiwyg"
                    dangerouslySetInnerHTML={{
                      __html: draftToHtml(t(_.get(data, 'our_goals_text')))
                    }}
                  />
                </div>
                <div className="col-md-7">
                  <div className="image">
                    <Image src={media_our_goals_image_full_file_path} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section-6">
          <div className="top-panel">
            <div className="container">
              <div className="title">{t('Service')}:</div>
            </div>
          </div>
          <div className="content-panel">
            <div className="container">
              <div className="row">
                {_.map(_.get(data, 'our_services'), (value, key) => {
                  const size = 12 / _.size(_.get(data, 'our_services'));
                  const media_icon_full_file_path = `${getServiceUrl()}/${_.get(value, 'media_icon_data.path')}`;
                  return (
                    <div key={key} className={`col-md-${size}`}>
                      <div className="block">
                        <div className="left">
                          <div className="icon">
                            <Image src={media_icon_full_file_path} />
                          </div>
                        </div>
                        <div className="right">
                          <div
                            className="title"
                            dangerouslySetInnerHTML={{
                              __html: t(_.get(value, 'title'))
                            }}
                          />
                          <div
                            className="detail"
                            dangerouslySetInnerHTML={{
                              __html: t(_.get(value, 'detail'))
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/About.js